import md5 from 'md5';
import { Message } from '@bijie/react-bnb';

import actionTypes from './types';
import { requestApiOrLoginRedirect } from '../utils/makeApiRequest';
import bog from '../utils/moreBog';
import { csrfMatches } from '../utils/csrfMatches';

const {
  FETCH_WITHDRAW_ADDRESS,
  FETCH_WITHDRAW_ADDRESS_SUCCESS,
  FETCH_WITHDRAW_ADDRESS_FAILED,
  FETCH_ASSET_LOG_EXTRA_DETAIL,
  FETCH_ASSET_LOG_EXTRA_DETAIL_SUCCESS,
  FETCH_ASSET_LOG_EXTRA_DETAIL_FAILED,
  SET_CHARGE_ADDRESS,
  SET_GENERATE_USER_CHARGE_ADDRESS,
  FETCH_USER_MONEY_LOG_CRYPTO_SUCCESS,
  FETCH_USER_MONEY_LOG_CRYPTO_FAILED,
} = actionTypes;

const FETCH_WITHDRAW_ADDRESS_API_PATH = '/withdraw/getAddressList.html';
export const USER_MONEY_LOG_API_PATH = '/user/getMoneyLog.html';
const GET_CHARGE_ADDRESS_API_PATH = '/charge/getChargeAddress.html';
const FETCH_ASSET_LOG_EXTRA_DETAIL_API_PATH = '/user/getAssetLogExtraDetail.html';
const USER_GENERATE_USER_CHARGE_ADDRESS_API_PATH = '/charge/resetChargeAddress.html';
const WITHERAW_RESEND_EMAIL_API_PATH = '/assetWithdraw/reSendMail.html'; // '/gateway-api/v1/private/capital/withdraw/reSendMail';
const WITHERAW_CANCEL_API_PATH = '/assetWithdraw/cancelWithdraw.html'; // '/gateway-api/v1/private/capital/withdraw/cancel';

export const fetchWithdrawAddress = coin => async dispatch => {
  dispatch({ type: FETCH_WITHDRAW_ADDRESS });
  try {
    const data = await requestApiOrLoginRedirect(
      `${FETCH_WITHDRAW_ADDRESS_API_PATH}?coin=${coin}`,
      null,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          csrftoken: md5(csrfMatches()[1]),
          clienttype: 'web',
        },
      }
    );
    dispatch({ type: FETCH_WITHDRAW_ADDRESS_SUCCESS, data });
  } catch (error) {
    dispatch({ type: FETCH_WITHDRAW_ADDRESS_FAILED, error });
  }
};


export const fetchChargeAddress = postData => async dispatch => {
  const params = new URLSearchParams();
  Object.keys(postData).forEach(key => {
    params.set(key, postData[key]);
  });
  try {
    dispatch({ type: SET_CHARGE_ADDRESS, data: {} });
    const data = await requestApiOrLoginRedirect(GET_CHARGE_ADDRESS_API_PATH, null, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        csrftoken: md5(csrfMatches()[1]),
        clienttype: 'web',
        // lang: locale,
      },
      body: params,
    });
    dispatch({ type: SET_CHARGE_ADDRESS, data });
  } catch (error) {
    bog.error(error);
  }
};

export const fetchGenerateUserChargeAddress = (locale, postData) => async dispatch => {
  try {
    dispatch({ type: SET_GENERATE_USER_CHARGE_ADDRESS, data: {} });
    const params = new URLSearchParams();
    Object.keys(postData).forEach(key => {
      params.set(key, postData[key]);
    });
    const data = await requestApiOrLoginRedirect(USER_GENERATE_USER_CHARGE_ADDRESS_API_PATH, null, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        csrftoken: md5(csrfMatches()[1]),
        clienttype: 'web',
        lang: locale,
      },
      body: params,
    });
    if (!data.success) {
      throw new Error(data.msg);
    }
    dispatch({ type: SET_GENERATE_USER_CHARGE_ADDRESS, data: data.model });
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchAssetLogExtraDetail = postData => async dispatch => {
  dispatch({ type: FETCH_ASSET_LOG_EXTRA_DETAIL });
  try {
    const params = new URLSearchParams();
    Object.keys(postData).forEach(key => {
      params.set(key, postData[key]);
    });

    const data = await requestApiOrLoginRedirect(
      FETCH_ASSET_LOG_EXTRA_DETAIL_API_PATH,
      null,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          csrftoken: md5(csrfMatches()[1]),
          clienttype: 'web',
        },
        body: params,
      }
    );
    dispatch({ type: FETCH_ASSET_LOG_EXTRA_DETAIL_SUCCESS, data, paymentId: postData.paymentId });
  } catch (error) {
    dispatch({ type: FETCH_ASSET_LOG_EXTRA_DETAIL_FAILED, error });
  }
};


export const fetchUserMoneyLogCrypto = (postData, locale) => async dispatch => {
  try {
    const params = new URLSearchParams();
    Object.keys(postData).forEach(key => {
      params.set(key, postData[key]);
    });
    const result = await requestApiOrLoginRedirect(USER_MONEY_LOG_API_PATH, null, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        csrftoken: md5(csrfMatches()[1]),
        clienttype: 'web',
        lang: locale,
      },
      body: params,
    });
    dispatch({ type: FETCH_USER_MONEY_LOG_CRYPTO_SUCCESS, data: result });
  } catch (error) {
    dispatch({ type: FETCH_USER_MONEY_LOG_CRYPTO_FAILED, error });
  }
};
export const withdrawResendEmail = async (postData, locale) => {
  let result = {};
  try {
    const params = new URLSearchParams();
    Object.keys(postData).forEach(key => {
      params.set(key, postData[key]);
    });

    result = await requestApiOrLoginRedirect(WITHERAW_RESEND_EMAIL_API_PATH, null, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        csrftoken: md5(csrfMatches()[1]),
        clienttype: 'web',
        lang: locale,
      },
      body: params,
    });
    if (result.success) {
      Message.success('success', 2);
      return true;
    }
    Message.fail(result.msg, 2);
    return false;
  } catch (error) {
    result = error;
  }
  return result;
};

export const withdrawCancel = (postData, locale) => async (dispatch) => {
  let result = {};
  try {
    const params = new URLSearchParams();
    Object.keys(postData).forEach(key => {
      params.set(key, postData[key]);
    });

    result = await requestApiOrLoginRedirect(WITHERAW_CANCEL_API_PATH, null, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        csrftoken: md5(csrfMatches()[1]),
        clienttype: 'web',
        lang: locale,
      },
      body: params,
    });
    if (result.success) {
      dispatch(fetchUserMoneyLogCrypto({ direction: 1, page: 1, row: 12 }, locale));
      return;
    }
    Message.fail(result.msg, 2);
  } catch (error) {
    result = error;
  }
};
